import { Component } from "react";

import { useEffect, useState } from "react";

// class Counter extends Component {

//   constructor(props) {
//     super(props);
//     console.log("this.props.name",this.props.name);
//     this.state = { count: 0}
//   }

//   componentDidMount() {
//     console.log("componentDidMount");
//   }

//   componentDidUpdate() {
//     console.log("componentDidUpdate");
//   }

//   componentWillUnmount() {
//     console.log("componentWillUnmount");
//   }

//   increment = () => {
//     this.setState({ count: this.state.count + 1})
//   }

//   number = 2332;

//   render() {
//     return(<>
//     <div>
//       <h1>Hi, May name is {this.props.name} and my age is {this.state.count}</h1>
//       <button onClick = {this.increment}>Click to increase {this.number}</button>
//     </div>
//     </>)
//   }
// }
// export default Counter

function Counter(props) {

  const [count, setCount] = useState(0);
  const increment = () => {
    setCount(count+1)
  }

  useEffect(() =>{
    console.log("Mounted or Updated");

    return () => {
      console.log("Unmounted");
    };
  }, [count])

  return(<>
    <div>
      <h1>Hi, May name is {props.name} and my age is {count}</h1>
      <button onClick={increment}>Click to Increase</button>
    </div>
  </>)
}

export default Counter;



